// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { AccountTransfer } from './account-transfer';
import { Batch } from './batch';
import { Entry } from './entry';
import { Lodgement } from './lodgement';
import { Lookup } from './lookup';
import { TransferLiability } from './transfer-liability';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class Transfer extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  transferId!: number;
  batchId?: number;
  createdBy!: string;
  createdDate!: Date;
  data?: string;
  fileId?: string;
  fileName?: string;
  flags?: number;
  fromDate?: Date;
  infoMsg?: string;
  lastPollDate?: Date;
  lodgementId?: number;
  processed!: number;
  source!: string;
  toDate?: Date;
  transferDate!: Date;
  transferTypeLookupId!: number;
  ts!: string;
  uid?: string;
  accountTransfers!: AccountTransfer[];
  batch!: Batch;
  entries!: Entry[];
  lodgement!: Lodgement;
  transferLiabilities!: TransferLiability[];
  transferTypeLookup!: Lookup;
}

